type DetailsPageProps = {
  children: React.ReactNode;
};

export const DetailsPagePassword = ({ children }: DetailsPageProps) => {
  return (
    <div className='relative z-0 flex h-screen w-full items-center justify-center overflow-hidden bg-primary-gray'>
      <div className='absolute left-0 top-1/2 z-0 aspect-square h-[180vh] -translate-x-1/2 -translate-y-1/2 rounded-full bg-secondary-light-blue-gray outline outline-[100px] outline-secondary-light-gray' />
      <div className='absolute left-0 top-0 z-20 aspect-square h-[110vh] -translate-x-1/2 -translate-y-1/2 rounded-full border-none bg-gradient-radial from-secondary-steel-blue from-10% to-secondary-light-blue-gray to-70%' />
      <div className='absolute left-0 top-full z-10 aspect-square h-[70vh] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-radial from-secondary-pale-blue-gray from-40% to-secondary-light-blue-gray to-60%' />
      <div className='absolute bottom-0 right-0 z-20 aspect-square h-[110vh] translate-x-1/2 translate-y-1/2 rounded-full border-none bg-gradient-radial from-secondary-light-blue-gray from-40% to-primary-gray to-60%' />
      <div className='absolute right-0 top-0 aspect-square h-[75vh] -translate-y-1/2 translate-x-1/2 rounded-full border-none bg-gradient-radial from-primary-white from-30% to-primary-gray to-60%' />
      {children}
    </div>
  );
};
